"use client";
import React from "react";
import PropTypes from "prop-types";
import { Item } from "semantic-ui-react";
import Link from "next/link";
const NewItemData = ({
  source,
  head,
  subhead,
  desc,
  extra,
  userid,
  href,
  ...props
}) => {
  return (
    <Item.Group>
      <Item>
        <Link href="" passHref>
          {userid && subhead === "realtor" ? (
            // <a
            //   style={{ cursor: "pointer", marginRight: 0 }}
            //   target="_blank"
            //   href={`/ProfileRealtor/?id=${userid}`}
            // >
            <Item.Image
              {...props}
              src={source}
              style={{ cursor: "pointer", marginRight: 0 }}
              target="_blank"
              href={`/ProfileRealtor/?id=${userid}`}
            />
          ) : (
            // </a>
            // <a style={{ marginRight: 0 }}>
            <Item.Image {...props} src={source} style={{ marginRight: 0 }} />
            // </a>
          )}
        </Link>
        <Item.Content verticalAlign="top" style={{ textAlign: "center" }}>
          {userid && subhead === "Real Estate Agent" ? (
            <Link
              href={`/ProfileRealtor/?id=${userid}`}
              target="_blank"
              style={{ cursor: "pointer", marginRight: 0 }}
            >
              {/* <a
                target="_blank"
                href={`/ProfileRealtor/?id=${userid}`}
                style={{ cursor: "pointer", marginRight: 0 }}
              > */}
              <Item.Header
                content={head}
                style={{
                  cursor: "pointer",
                  fontSize: 16,
                  fontWeight: "bold",
                  color: "#1b57a5",
                }}
              />
              {/* </a> */}
            </Link>
          ) : (
            <Link
              href={`/ProfileUser/?id=${userid}`}
              target="_blank"
              style={{ cursor: "pointer", marginRight: 0 }}
            >
              {/* <a
                target="_blank"
                href={`/ProfileUser/?id=${userid}`}
                style={{ cursor: "pointer", marginRight: 0 }}
              > */}
              <Item.Header
                content={head}
                style={{
                  cursor: "pointer",
                  fontSize: 16,
                  fontWeight: "bold",
                  color: "#1b57a5",
                }}
              />
              {/* </a> */}
            </Link>
          )}
          {subhead && subhead === "Real Estate Agent" ? (
            <Item.Meta
              content={subhead}
              style={{ margin: 0, textAlign: "center" }}
            />
          ) : null}
          {desc ? <Item.Description content={desc} {...props} /> : null}
          {extra ? <Item.Extra content={extra} /> : null}
        </Item.Content>
      </Item>
    </Item.Group>
  );
};

NewItemData.propTypes = {
  source: PropTypes.string,
  head: PropTypes.any,
  subhead: PropTypes.any,
  description: PropTypes.any,
  desc: PropTypes.any,
  extra: PropTypes.any,
};
export default NewItemData;
